var CAROUSEL_VARIANTS = ['noImage carousel', 'vertical carousel'];
var NO_PAGINATION_VARIANTS = ['vertical no-pagination', 'featured no-pagination', 'noImage no-pagination'];
var NO_PAGINATE_VARIANTS = [].concat(CAROUSEL_VARIANTS, NO_PAGINATION_VARIANTS);
var cardVariantsMap = {
  'noImage carousel': 'noImage',
  'noImage no-pagination': 'noImage',
  noImage: 'noImage',
  'vertical carousel': 'vertical',
  'vertical no-pagination': 'vertical',
  vertical: 'vertical',
  'featured no-pagination': 'featured',
  featured: 'featured',
  default: undefined
};

export { CAROUSEL_VARIANTS, NO_PAGINATE_VARIANTS, NO_PAGINATION_VARIANTS, cardVariantsMap };
